import React from "react";

import { store } from '../../redux/store';
import { connect } from "react-redux";
import history from "../../auth/history";
import { selectedConsumerList } from "../../redux/misc-data/misc-data.action";
import moment from "moment";
import { TimeScale } from "chart.js";

class BillListSubComponent extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			phoneNo: this.props.phone,
			noDue: '',
			nextFetchDate: '',
			fetchedOn: '',
			overDue:''
		}
	}


	componentDidMount() {
		setInterval(() => {
			if (this.props.selectedConsumers != undefined &&
				this.props.selectedConsumers.length > 0) {
				var val = JSON.stringify(this.props.selectedConsumers);
				var id = this.props.consumer.id;
				if (val.includes(id)) {
					this.setState({
						noDue: "checked"
					})
				} else {
					this.setState({
						noDue: "unChecked"
					})
				}
			} else {
				this.setState({
					noDue: "unChecked"
				})
			}

			if(this.props.consumer.dueDate!=undefined &&
				this.props.consumer.dueDate!=null){
					var date=new Date();
					var date1 = moment(this.props.consumer.dueDate).format('YYYY-MM-DD HH:mm:ss');
					var date2=new Date(date1);
					if(date<date2){
						this.setState({
							overDue:"false"
						})

					}else{
						this.setState({
							overDue:"true"
						})
					}
				}

			if (this.props.consumer.fetchRequired == true &&
				this.props.consumer.lastBillFetch != undefined &&
				this.props.consumer.lastBillFetch != null &&
				this.props.consumer.lastBillFetch != '' &&
				this.props.consumer.lastBillFetch.fetchedOn != undefined &&
				this.props.consumer.lastBillFetch.fetchedOn != null &&
				this.props.consumer.lastBillFetch.fetchedOn != '' &&
				this.props.consumer.nextBllFetchDate != undefined &&
				this.props.consumer.nextBllFetchDate != null &&
				this.props.consumer.nextBllFetchDate != '') {
				// alert('here')
				var fetchedOn = this.props.consumer.lastBillFetch.fetchedOn;
				var date = moment(fetchedOn).format('YYYY-MM-DD HH:mm:ss');
				console.log('date..' + date)
				var date1 = new Date(date);
				var dateValue = date1.getDate();
				console.log('dateValue:' + dateValue)
				//var dayVal = new Date(date.getFullYear(), date.getMonth(), 0);

				if (dateValue > this.props.consumer.nextBllFetchDate) {
					// alert('here1')
					var dayVal = new Date(date1.getFullYear(), date1.getMonth() + 1, this.props.consumer.nextBllFetchDate);
					this.setState({
						fetchedOn: date,
						nextFetchDate: moment(dayVal).format('DD/MM/YYYY')
					})



				}
				if (dateValue < this.props.consumer.nextBllFetchDate) {

					var dayVal = new Date(date1.getFullYear(), date1.getMonth(), this.props.consumer.nextBllFetchDate);
					this.setState({
						fetchedOn: date,
						nextFetchDate: moment(dayVal).format('DD/MM/YYYY')
					})
				}
				if (dateValue == this.props.consumer.nextBllFetchDate) {

					var dayVal = new Date(date1.getFullYear(), date1.getMonth() + 1, this.props.consumer.nextBllFetchDate);
					this.setState({
						fetchedOn: date,
						nextFetchDate: moment(dayVal).format('DD/MM/YYYY')
					})
				}

			}

		}, 100);







	}
	componentWillUnmount() {
	}

	rowChecked = (event, consumer) => {
		event.preventDefault();


		if (consumer.lastKnownStatus == "BILL_FETCH_SUCCESS"
			|| consumer.lastKnownStatus == "NO_FETCH_REQUIRED"
			|| consumer.lastKnownStatus == "CREATE_ORDER_FAILED"
			|| consumer.lastKnownStatus == "BILL_PAY_FAILED"
			|| consumer.lastKnownStatus == "BILL_FETCH_FAILED") {
				//alert(this.state.noDue)
				
				
			if (this.state.noDue == "unChecked") {
				var selectedConsumers = this.props.selectedConsumers;
				if(consumer.lastKnownStatus == "BILL_FETCH_FAILED"){
					selectedConsumers.push(consumer)
				}

				if (selectedConsumers.length > 0) {

					if (consumer.fetchRequired == false) {
						const index = selectedConsumers.indexOf(consumer);


						if (index == -1) {
							selectedConsumers.push(consumer);
							store.dispatch(selectedConsumerList(selectedConsumers));
							// setTimeout(() => {
							// 	this.setState({
							// 		noDue: "checked"
							// 	})

							// }, 100);
						}
					} else {
						
						if (consumer.currentBillPayAmount != undefined &&
							consumer.currentBillPayAmount != null &&
							consumer.currentBillPayAmount > 0) {

							const index = selectedConsumers.indexOf(consumer);
							if (index == -1) {
								selectedConsumers.push(consumer);
								store.dispatch(selectedConsumerList(selectedConsumers));
								// setTimeout(() => {
								// 	this.setState({
								// 		noDue: "checked"
								// 	})

								// }, 100);
							}


						}
					}




				} else {

					if (consumer.fetchRequired == false) {

						var arr = [];
						arr.push(consumer);
						store.dispatch(selectedConsumerList(arr));
						// setTimeout(() => {
						// 	this.setState({
						// 		noDue: "checked"
						// 	})

						// }, 100);

					} else {
						if (consumer.currentBillPayAmount != undefined &&
							consumer.currentBillPayAmount != null &&
							consumer.currentBillPayAmount > 0
						) {
							var arr = [];
							arr.push(consumer);
							store.dispatch(selectedConsumerList(arr));
							// setTimeout(() => {
							// 	this.setState({
							// 		noDue: "checked"
							// 	})

							// }, 100);

						}

					}



				}
			}
			if (this.state.noDue == "checked") {

				if (consumer.fetchRequired == false) {
					var selectedConsumers = this.props.selectedConsumers;
					if (selectedConsumers != undefined) {

						const index = selectedConsumers.indexOf(consumer);

						selectedConsumers.splice(index, 1);
						store.dispatch(selectedConsumerList(selectedConsumers));

						// setTimeout(() => {
						// 	this.setState({
						// 		noDue: "unChecked"
						// 	})

						// }, 100);
					}
				} else {
					var selectedConsumers = this.props.selectedConsumers;
					if (selectedConsumers != undefined) {

						const index = selectedConsumers.indexOf(consumer);

						selectedConsumers.splice(index, 1);
						store.dispatch(selectedConsumerList(selectedConsumers));

						// setTimeout(() => {
						// 	this.setState({
						// 		noDue: "unChecked"
						// 	})

						// }, 100);
					}
				}

			}
		}

	}


	render() {

		return (
			<div class={
				(this.props.consumer.lastKnownStatus == 'CREATE_ORDER_FAILED' ||
					this.props.consumer.lastKnownStatus == 'BILL_FETCH_SUCCESS' ||
					this.props.consumer.lastKnownStatus == 'NO_FETCH_REQUIRED' ||
					this.props.consumer.lastKnownStatus == 'BILL_PAY_FAILED'||
					this.props.consumer.lastKnownStatus == "BILL_FETCH_FAILED") ?
					this.state.noDue == "checked" ? "billist nodue checked" :
						"billist ovrdue" :
					"billist ovrdue"}>
				{/* //billlkist type=ovrdue */}



				<div class="row" onClick={e => this.rowChecked(e, this.props.consumer)}>
					<div class="col-12 col-md-3">
						<div class="duetxt csname">
							<h5>{this.props.consumer.consumerName.toLocaleUpperCase()}</h5>
							<p>+91-{this.props.consumer.mobileNo}</p>
						</div>
					</div>
					<div class="col-12 col-md-5">
						<div class="duetxt">
							<h5>{this.props.consumer.billerName}</h5>
							<h5>{Object.entries(this.props.consumer.optional).map(([key, value]) => `${key}=${value}`).join('&')}</h5>
							{this.state.fetchedOn != '' &&
								<h5>Current Bill Fetch :{moment(this.state.fetchedOn).format('DD/MM/YYYY')}</h5>
							}
							{this.state.nextFetchDate != '' &&
								<h5>Next Bill Fetch :{this.state.nextFetchDate}</h5>
							}
						</div>
					</div>


					<div class="col-6 col-md">
						{this.props.consumer.fetchRequired == true ?
							<div class="duetxt">
								<p>Bill Due Date</p>
								<h5>{(this.props.consumer.lastBillFetch != undefined &&
									this.props.consumer.lastBillFetch != null &&
									this.props.consumer.lastBillFetch != "" &&
									this.props.consumer.lastBillFetch.dueDate != undefined &&
									this.props.consumer.lastBillFetch.dueDate != null &&
									this.props.consumer.lastBillFetch.dueDate != "") ?
									this.props.consumer.lastBillFetch.dueDate : "NA"
								}</h5>
								{(this.state.overDue!='') &&
									<h5>Due date over:{this.state.overDue}</h5>}
							</div> :
							<div class="duetxt">
								<p>Bill Due Date</p>
								<h5>Not Required</h5>
							</div>

						}
					</div>
					{/* <div class="col-6 col-md">
						{this.state.fetchedOn != '' &&
							<div class="duetxt">
								<p>Current Fetch</p>
								<h5>{moment(this.state.fetchedOn).format('DD/MM/YYYY')}</h5>
							</div>
						}
						{this.state.nextFetchDate != '' &&
							<div class="duetxt">
								<p>Next Fetch</p>
								<h5>{this.state.nextFetchDate}</h5>
							</div>
						}
					</div> */}


					<div class="col-6 col-md">
						{this.props.consumer.fetchRequired == true ?
							<div class="duetxt text-end">
								<p>Bill Amount</p>
								<h5> {(this.props.consumer.currentBillPayAmount != undefined &&
									this.props.consumer.currentBillPayAmount != null &&
									this.props.consumer.currentBillPayAmount != "")
									?
									this.props.consumer.currentBillPayAmount.toLocaleString("en-US") :
									(this.props.consumer.lastPaidBill != undefined &&
										this.props.consumer.lastPaidBill != null &&
										this.props.consumer.lastPaidBill != "" &&
										this.props.consumer.lastPaidBill.lastPaidBillAmount != undefined &&
										this.props.consumer.lastPaidBill.lastPaidBillAmount != null &&
										this.props.consumer.lastPaidBill.lastPaidBillAmount != "") ?
										this.props.consumer.lastPaidBill.lastPaidBillAmount :
										"NA"}
								</h5>
							</div> :
							<div class="duetxt text-end">
								<p>Last Bill Amount(Manual)</p>
								<h5> {(this.props.consumer.currentBillPayAmount != undefined &&
									this.props.consumer.currentBillPayAmount != null &&
									this.props.consumer.currentBillPayAmount != "")
									?
									this.props.consumer.currentBillPayAmount.toLocaleString("en-US") :
									(this.props.consumer.lastPaidBill != undefined &&
										this.props.consumer.lastPaidBill != null &&
										this.props.consumer.lastPaidBill != "" &&
										this.props.consumer.lastPaidBill.lastPaidBillAmount != undefined &&
										this.props.consumer.lastPaidBill.lastPaidBillAmount != null &&
										this.props.consumer.lastPaidBill.lastPaidBillAmount != "") ?
										this.props.consumer.lastPaidBill.lastPaidBillAmount :
										"0"}
								</h5>
							</div>
						}
					</div>
					<div class="col-6 col-md">
						<div class="duetxt text-end">
							<p>Last status</p>
							{this.props.consumer.fetchRequired == true &&

								<h5> {(this.props.consumer.lastKnownStatus != undefined) ?
									this.props.consumer.lastKnownStatus.split('_').join(' ') : "NA"}
								</h5>
							}
							{this.props.consumer.fetchRequired == false &&

								<h5> {(this.props.consumer.lastKnownStatus != undefined) ?
									this.props.consumer.lastKnownStatus.split('_').join(' ') + "(Manual Billpay)" : "NA"}
								</h5>
							}
						</div>
					</div>
				</div>
			</div>
		);
	}
}

const mapStateToProps = (
	{ errorMessageReduce: { errorMessage, loginErrorMessage },
		miscReduce: { phone, selectedConsumers } }
) => ({
	errorMessage, loginErrorMessage, phone, selectedConsumers
});

export default connect(mapStateToProps, null)(BillListSubComponent);
